import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const ChatPage = lazy(() => import("./ChatPage"));

const ChatPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <ChatPage />
    </Suspense>
  );
};

export default ChatPageLazy;
